import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Drop-in JSON-LD blocks for SEO rich results.
 * Each component renders a single <script type="application/ld+json"> into <head>.
 */

function jsonLd(obj) {
  return JSON.stringify(obj);
}

export function LocalBusinessLD({ origin, settings = {}, heroImageUrl }) {
  const data = {
    "@context": "https://schema.org",
    "@type": "MusicStore",
    name: settings.business_name || "Glazbalarski obrt Mario Žmegač",
    legalName: settings.business_name || "Glazbalarski obrt Mario Žmegač",
    alternateName: "Tambure Žmegač",
    description: "Hand-built Croatian tamburitzas in Varaždin since 1988.",
    image: heroImageUrl || `${origin}/seed/workshop_mainpage_hero.webp`,
    url: origin,
    telephone: [
      settings.business_phone_landline_tel || "+38542262032",
      settings.business_phone_mobile_tel || "+38598284876",
    ],
    email: settings.business_email || "tamburezmegac@gmail.com",
    address: {
      "@type": "PostalAddress",
      streetAddress: settings.business_address_line || "Ivana Rangera 44",
      addressLocality: settings.business_address_city || "Varaždin",
      postalCode: settings.business_address_postal || "42000",
      addressCountry: "HR",
    },
    openingHoursSpecification: [
      { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "09:00", closes: "17:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Saturday", opens: "09:00", closes: "13:00" },
    ],
    priceRange: "Price on request",
    foundingDate: "1988",
  };
  return (
    <Helmet>
      <script type="application/ld+json">{jsonLd(data)}</script>
    </Helmet>
  );
}

export function ProductLD({ origin, product, locale = "hr", canonicalUrl }) {
  if (!product) return null;
  const mode = product.mode || "custom_build";
  const availability = mode === "ready_stock"
    ? "https://schema.org/InStock"
    : "https://schema.org/MadeToOrder";
  // priceValidUntil = +1 year ISO date (yyyy-mm-dd)
  const validUntil = (() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() + 1);
    return d.toISOString().slice(0, 10);
  })();
  const data = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: `${product.name} — ${"Tambure Žmegač"}`,
    description: product.description || product.tagline || "",
    image: product.hero_image_url ? `${origin}${product.hero_image_url}` : `${origin}/seed/workshop_hero.webp`,
    sku: product.id,
    brand: { "@type": "Brand", name: "Tambure Žmegač" },
    category: "Musical Instruments > Stringed Instruments > Tamburitza",
    // No `offers` block — pricing is inquiry-first (contact-based). Google still
    // indexes name/description/image without a rich-result price display.
    inLanguage: locale,
  };
  return (
    <Helmet>
      <script type="application/ld+json">{jsonLd(data)}</script>
    </Helmet>
  );
}

export function BreadcrumbLD({ origin, items }) {
  if (!items || items.length === 0) return null;
  const data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: it.name,
      item: it.url?.startsWith("http") ? it.url : `${origin}${it.url || "/"}`,
    })),
  };
  return (
    <Helmet>
      <script type="application/ld+json">{jsonLd(data)}</script>
    </Helmet>
  );
}
